<template>
  <div>
    <div v-for="(upload, index) in uploads" :key="index" class="mt-2 mb-1 row">
      <div class="col-1 text-right">
        <button @click="confirmRemoveUpload(upload.prefix + '_filename', index)" type="button" class="btn btn-danger">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>
      <div class="col-11">
        <UploadForm :tag="'upload' + index" :mime="upload.mime" :prefix="upload.prefix" :bucket="bucket" :pool="pool"
          :region="region" :filename="upload.filename" :filesize="upload.filesize"
          v-on:uploading="setUploading(index, $event)" v-on:complete="setComplete(index, $event)" />
      </div>
      <!-- 削除ボタン -->
    </div>

    <button @click="addUpload" type="button" class="btn btn-primary">
      {{ __('attachments Add') }}
    </button>

    <form method="POST" action="/upload">
      <input v-for="(file, index) in postFiles" :key="'hiddenFile_' + index" type="hidden" :name="'upload_files[]'"
        :value="file" />
      <input v-for="(size, index) in postFileSizes" :key="'hiddenSize_' + index" type="hidden"
        :name="'upload_filesize[]'" :value="size" />
    </form>
  </div>
</template>

<script>
import UploadForm from "./UploadFormComponent.vue";

export default {
  name: "MultipleUpload",
  components: { UploadForm },
  props: {
    bucket: String,
    pool: String,
    region: String,
    prefix: String,
    existingUploads: Number,
  },
  data() {
    return {
      uploads: [
        // {
        //   mime: "attachments",
        //   prefix: this.prefix + "_0",
        //   filename: "",
        //   filesize: 0,
        // },
      ],
      postFiles: [],
      postFileSizes: [],
      maxUploads: 20,
    };
  },
  methods: {
    addUpload() {
      const totalUploads = this.existingUploads + this.uploads.length;

      // ファイル数制限チェック
      console.log('existingUploads=', this.existingUploads, '+ uploads.length=', this.uploads.length);
      if (totalUploads >= this.maxUploads) {
        alert("最大20ファイルまでしかアップロードできません。");
        return;
      }

      const newIndex = this.uploads.length;
      this.uploads.push({
        mime: "attachments",
        prefix: `${this.prefix}_${newIndex}`,
        filename: "",
        filesize: 0,
      });
    },
    confirmRemoveUpload(hiddenFieldId, index) {
      const hiddenField = document.getElementById(hiddenFieldId);
      console.log(hiddenFieldId)
      console.log(hiddenField)

      if (hiddenField && hiddenField.value) {
        const confirmDelete = confirm(
          this.__('I really delete this?')
        );
        if (!confirmDelete) {
          return; // キャンセルの場合は処理を中断
        }
      }

      this.removeUpload(index);
    },
    removeUpload(index) {
      // アップロードリストから該当インデックスを削除
      this.uploads.splice(index, 1);

      // postFiles, postFileSizes からも該当データを削除
      this.postFiles.splice(index, 1);
      this.postFileSizes.splice(index, 1);
    },
    setUploading(index, isUploading) {
      console.log(`Uploading state for upload ${index}: ${isUploading}`);
    },
    setComplete(index, tag) {
      const upload = this.uploads[index];

      // 子コンポーネントで設定された filename, filesize を取得
      this.$set(this.postFiles, index, upload.filename);
      this.$set(this.postFileSizes, index, upload.filesize);
    },
  },
};
</script>
